import { useMemo, useState, useEffect } from "react";
import { useAllBook, useBookOrder } from "store/books/selectors";
import { useCurrentClass  } from "store/classes/selectors";
import { useCurrentOrgPermission } from "store/organizations/selectors";
import { get, find } from "lodash";

export const useCurrentClassActiveBooks = () => {
    const currentClass = useCurrentClass();
    const booksAllList = useAllBook();
    const bookOrder = useBookOrder();
    const orgPermissions = useCurrentOrgPermission();
    const archived_group = currentClass.archived_group || [];
    const [allowedbooks, setAllowedbooks] = useState([]);
    const orderedBook = useMemo(() => {
        let order_group = [];
        const books_group_permission = get(orgPermissions, "books_group_permission", []);
        (bookOrder || []).forEach((order) => {
            const class_books_group = currentClass.books_group || []
            if (archived_group.includes(order.key)) return null;
            if (books_group_permission.length == 0 || books_group_permission.includes(order.key)) {
                const has_book = find(class_books_group, k => k == order.key);
                if (has_book) {
                    const result = [...(order && order.order && order.order.map((chapter) => {
                        const book = find(booksAllList, ["id", chapter]);
                        if (book) {
                            return book;
                        }
                        return null;
                    }).filter(Boolean))]
                    order_group.push({
                        key: order.key,
                        title: order.title,
                        color: order.color,
                        books: result
                    })
                }
            }
        });
        return order_group;
    }, [currentClass, orgPermissions, booksAllList]);
    useEffect(() => {
        const allowed_books = [];
        try {
            if (currentClass && currentClass.id) {
                if (orderedBook.length > 0) {
                    orderedBook.forEach(book => {
                        book.books.forEach(bk => {
                            if (!bk) {
                                return;
                            }
                            const is_hidden = currentClass?.hide_books.find(f => f.bookId == bk.id && f.group == book.title);
                            const is_onlyTeacher = bk.onlyTeacher;
                            const is_not_assignable = bk.isNotAssignable;
                            if (is_hidden || is_onlyTeacher || is_not_assignable) {
                                return;
                            }
                            else {
                                allowed_books.push({
                                    id: bk.id,
                                    description: bk.description,
                                    image: bk.img,
                                });
                            }
                        });
                    });
                }
            }
            setAllowedbooks(allowed_books); 
        } catch (error) {
            console.log("error", error);
        }
    }, [orderedBook, currentClass]);


    return {
        allowedbooks
    }

}